export const endpoints = {
  annotations: 'annotations',
  appointments: 'appointments',
  events: 'events',
  fmxGroup: 'fmx-group',
  images: 'images',
  estimatedVisits: 'estimated-visits',
  insights: 'insights',
  summary: 'summary',
  latestImages: 'latest-images',
  organizations: 'organizations',
  patient: 'patient',
  practice: 'practice',
  practices: 'practices',
  productionOverTime: 'productionOverTime',
  preferences: 'preferences',
  preferencesHistory: 'preferences/history',
  rblSettings: 'rblsettings',
  userModifications: 'user-modifications',
  users: 'users',
  validation: 'validation',
  visits: 'visits',
  insuranceClaim: 'insurance-claim',
  pdfSummary: 'pdf-summary',
  pdfGenerate: 'claim-summary/generate-print-view',
  claimWriteback: 'claim-summary/writeback',
  claimWritebackSupport: 'claim-summary/writeback-support',
  claimWritebackStatus: 'claim-summary/writeback-status',
  generatePieces: 'claim-summary/generate-pieces',
  patientAnalysesPreview: 'patient-analyses-preview',
  treatmentValues: 'treatmentValues',
  incompleteTreatments: 'incompleteTreatments',
  patientFindings: 'patientFindings',
  metrics: 'metrics',
  recap: 'recap',
  confidenceThresholds: 'confidenceThresholds',
  analyzeImageHistorical: 'analyze-image/historical',
  unifiedAppointmentToImagingPatientIdMapping:
    'unified-appointment-to-imaging-patient-id-mapping',
  fmxSummary: 'fmx-summary',
  fmxSummaries: 'fmx-summaries',
  narrative: 'narrative',
  insuranceSummary: 'insuranceSummary',
  insuranceSummaryDev: 'insuranceSummaryDev',
  tasks: 'tasks',
  dailyGoals: 'daily-goals',
  localization: 'localization',
  v2: 'v2',
  v3: 'v3',
  videaInsights: 'videa-insights',
  practiceGroups: 'practice-groups',
  saveAttachmentAudit: 'claim-summary/save-audit-entry',
  claimFindings: 'claim-summary/findings',
  visitSummaries: 'visit-summaries',
  claimTreatments: 'claim-summary/treatments',
  claimBatchFindings: 'claim-summary/batch-findings',
  analyses: 'analyses',
  getVideaImageId: 'get-videa-image-id',
  getVideaPatientId: 'get-videa-patient-id',
  external: 'external',
  patientDownloadable: 'patient-downloadable',
  data: 'data',
  ambient: {
    voiceNotes: {
      combinedAppointmentsList: 'videa-notes/search-appointments',
      searchNotesByCreatedAt: 'videa-notes/search-notes',
      batchNotesByUnifiedAppointmentIds: 'videa-notes/appointment-notes/batch',
      batchNotesByStandalonePatientVisitIds:
        'videa-notes/standalone-patient-visit-notes/batch',
    },
    standalonePatientVisits: 'standalone-patient-visits',
  },
  parseShortCode: 'parse-short-code',
  pmsClinicalNotes: 'pms-clinical-notes',
  insightsSavedViews: 'insights-saved-views',
  referrals: 'referrals',
  referralsMetrics: 'referrals/metrics',
  referralsFilters: 'referrals/filters',
  referralsByReferralId: 'referrals/by-referral-id',
  referralsPractice: 'referrals/practice',
  referralsSpecialties: 'referrals/specialties',
  referralsPractices: 'referrals/practices',
  referralsSpecialists: 'referrals/specialists',
  zuubInsuranceList: 'zuub/insurance/list',
  zuubInsuranceListV3: 'zuub/insurance/v3/list',
  zuubInsuranceDetail: 'zuub/insurance/detail',
  zuubInsuranceDetailV3: 'zuub/insurance/v3/detail',
  reverseTrial: 'reverse-trial',
  status: 'status',
  rcmZuubOnboarding: {
    payers: 'rcm/onboarding/payers',
    begin: 'rcm/onboarding/begin',
    status: 'rcm/onboarding/status',
    configuration: 'rcm/onboarding/configuration',
    messages: 'rcm/onboarding/messages',
  },
  imageStatuses: 'image-statuses',
  sharpenedImages: 'sharpened-images',
  recentVisits: 'recent-visits',
  practiceAIImpact: 'practice-ai-impact',
  benefitsPdfGenerate: 'benefits-summary/generate-print-view',
  benefitsWriteback: 'benefits-summary/writeback',
  benefitsWritebackSupport: 'benefits-summary/writeback-support',
  perioChart: 'perio-chart',
  updateFmxSort: 'update-fmx-sort',
} as const;
